const errors = {
  NoRoomId: "Aucune salle n'est actuellement assignée à ce qr-code",
  forbidden: "Vous n'avez pas le droit d'accéder à cette ressource",
  'not-found': "Cette salle n'existe pas",
  TypeError: "Une erreur de communication avec le serveur est survenue",
  UNKNOWN: "Une erreur est survenue"
}

function getErrorMessage(error) {
  for(const e of Object.keys(errors)) {
    if (error.toString().includes(e)) 
      return errors[e]
  }

  return errors.UNKNOWN
}

export {
  getErrorMessage
}